

import { useTranslation } from "next-i18next";
import Button from "react-bootstrap/Button";


const CheckinSubmitButton = ({ checkStatus, disabledCheck, onClick = () => {} }) => {
    const { t } = useTranslation();
  
    const checkState = disabledCheck
      ? t("views.checkin.form.waiting")
      : checkStatus === "checkin"
      ? t("views.checkin.form.checkin")
      : t("views.checkin.form.checkout");
  
    const checkVariant = disabledCheck
      ? ""
      : checkStatus === "checkin"
      ? "success"
      : "danger";
  
    return (
      <Button
        form="checkin"
        type="submit"
        className="text-light"
        variant={checkVariant}
        style={
          disabledCheck
            ? {
                minWidth: 200,
                backgroundColor: "#d0dde6",
                borderColor: "#f6f6f6",
              }
            : { minWidth: 200 }
        }
        disabled={disabledCheck}
        onClick={onClick}
      >
        {checkState}
      </Button>
    );
  };
export default CheckinSubmitButton